import React, { useState } from 'react';
import { Icon } from 'assets/icons';
import { formatDateTime } from '../../config/job';
import styles from '../view.module.css';

export const JobVersionHistory = ({ versions = [], current_version }) => {
  const [is_open, setIsOpen] = useState(false);

  const prior_versions = [...versions]
    .filter((version) => version.version !== current_version)
    .sort((a, b) => b.version - a.version);

  if (prior_versions.length === 0) return null;

  return (
    <section className={styles.historyCard}>
      <button
        type="button"
        className={styles.historyToggle}
        onClick={() => setIsOpen((open) => !open)}
      >
        <span>
          {prior_versions.length} earlier {prior_versions.length === 1 ? 'version' : 'versions'}
        </span>
        <span className={`${styles.historyChevron} ${is_open ? styles.historyChevronOpen : ''}`}>
          <Icon name="expand" width={16} height={16} />
        </span>
      </button>

      {is_open && (
        <div className={styles.historyList}>
          {prior_versions.map((version) => (
            <div key={version.version} className={styles.historyItem}>
              <div className={styles.historyHead}>
                <span className={styles.historyVersion}>v{version.version}</span>
                {version.generated_at && (
                  <span className={styles.historyDate}>{formatDateTime(version.generated_at)}</span>
                )}
              </div>
              {version.rejection_comment ? (
                <>
                  <p className={styles.historyComment}>“{version.rejection_comment}”</p>
                  <p className={styles.historyMeta}>
                    Rejected by {version.rejected_by || 'unknown'}
                    {version.rejected_at ? ` · ${formatDateTime(version.rejected_at)}` : ''}
                  </p>
                </>
              ) : (
                <p className={styles.historyMeta}>No rejection comment on this version.</p>
              )}
            </div>
          ))}
        </div>
      )}
    </section>
  );
};
